import { Avatar, LabelRegular, TextMedium, TextRegular } from "@hm/fundamental"
import type { ReactNode } from "react"

interface ChangeLogEntryProps {
	date: string
	editor: string
	reason: string
	editorLabel: string
	reasonLabel: string
	children: ReactNode
	"data-cy": string
}

export const ChangeLogEntry: React.FC<ChangeLogEntryProps> = ({
	date,
	editor,
	reason,
	editorLabel,
	reasonLabel,
	children,
	"data-cy": dataCy,
}) => (
	<div
		data-cy={dataCy}
		className="flex flex-col gap-3 border-b border-border py-4 last:border-b-0"
	>
		<LabelRegular className="text-foreground_faded">{date}</LabelRegular>
		<div className="flex flex-wrap gap-x-10 gap-y-4">
			<div className="flex flex-col gap-2">{children}</div>
			<div className="flex flex-col gap-3">
				<div className="flex flex-col gap-1">
					<LabelRegular className="text-foreground_faded">
						{editorLabel}
					</LabelRegular>
					<div className="flex items-center gap-2">
						<Avatar name={editor} />
						<TextMedium className="text-foreground">
							{editor}
						</TextMedium>
					</div>
				</div>
				<div className="flex flex-col gap-1">
					<LabelRegular className="text-foreground_faded">
						{reasonLabel}
					</LabelRegular>
					<TextRegular className="text-foreground">
						{reason}
					</TextRegular>
				</div>
			</div>
		</div>
	</div>
)
